export default "__VITE_ASSET__6sXVIf7v__"